import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/DashboardAnalytic',
    name: 'DashboardAnalytic',
    component: () => import('../views/DashboardAnalytic.vue')
  },
  {
    path: '/SensorData',
    name: 'SensorData',
    component: () => import('../views/SensorData.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
